import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';

const api = axios.create({
  baseURL: config.baseUrl,
});

api.interceptors.request.use(
  (cfg) => {
    const token = Cookies.get('token');
    if (token) cfg.headers['Authorization'] = `Bearer ${token}`;
    return cfg;
  },
  (error) => Promise.reject(error)
);

// ─── Participantes ───────────────────────────────────────────────────────────

export const getParticipantes = async (project) => {
  try {
    const response = await api.get('/api/getParticipant', { params: { project } });
    return { status: response.status, data: response.data.Participantes };
  } catch (error) {
    return { status: error.response?.status || 500, message: 'Error fetching participants' };
  }
};

export const getParticipanteById = async (oid) => {
  try {
    const response = await api.get(`/api/getParticipant/${oid}`);
    return { status: response.status, data: response.data.participante };
  } catch (error) {
    console.error('Error fetching participant by ID:', error);
    return { status: error.response?.status || 500, message: 'Error fetching participant' };
  }
};

export const createParticipante = async (participanteData) => {
  try {
    const response = await api.post('/api/createParticipante', participanteData);
    return { status: response.status, data: response.data };
  } catch (error) {
    console.error('Error creating participant:', error);
    const status = error.response?.status || 500;
    const message = error.response?.data?.message || 'Error al crear participante';
    return { status, message, details: error.response?.data };
  }
};

export const updateParticipante = async (oid, participanteData, oid_participante_proyecto) => {
  try {
    const data = { ...participanteData, oidParticipanteProyecto: oid_participante_proyecto };
    const response = await api.put(`/api/updateParticipante/${oid}`, data);
    return { status: response.status, data: response.data };
  } catch (error) {
    console.error('Error updating participant:', error);
    return {
      status: error.response?.status || 500,
      message: 'Error updating participant',
      details: error.response?.data,
    };
  }
};

export const deleteParticipante = async (oid) => {
  try {
    const response = await api.delete(`/api/removeParticipante/${oid}`);
    return { status: response.status, data: response.data };
  } catch (error) {
    console.error('Error deleting participant:', error);
    return { status: error.response?.status || 500, message: 'Error deleting participant' };
  }
};

export const getParticipantesByProyecto = async (proyectoData) => {
  try {
    const response = await api.post('/api/getParticipantesxProyectos', proyectoData);
    return { status: response.status, data: response.data };
  } catch (error) {
    console.error('Error fetching participants by project:', error);
    return { status: error.response?.status || 500, message: 'Error fetching participants by project' };
  }
};

export const getCatalogosParticipante = async () => {
  try {
    const response = await api.get('/api/getDataParticipante');
    return { status: response.status, data: response.data.catalogos };
  } catch (error) {
    console.error('Error fetching catalogs:', error);
    return { status: error.response?.status || 500, message: 'Error fetching catalogs' };
  }
};

export const getMunicipiosByDepartamento = async (oidDepto) => {
  try {
    const response = await api.get(`/api/catalogos/municipios?departamentoId=${oidDepto}`);
    return { status: response.status, data: response.data.municipios };
  } catch (error) {
    console.error('Error fetching municipalities:', error);
    return { status: error.response?.status || 500, message: 'Error fetching municipalities' };
  }
};

export const getSoportesBulk = async (project) => {
  try {
    const response = await api.get('/api/participantes-soportes-bulk', { params: { project } });
    return { status: response.status, data: response.data };
  } catch (error) {
    return { status: error.response?.status || 500, data: {} };
  }
};

const participantesService = {
  getParticipantes,
  getParticipanteById,
  createParticipante,
  updateParticipante,
  deleteParticipante,
  getParticipantesByProyecto,
  getCatalogosParticipante,
  getMunicipiosByDepartamento,
  getSoportesBulk,
};

export default participantesService;